import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/feepay/dataProcess/page', Object.assign({}, options, { params }));

export const getTotalMoney = (params, options) =>
  request.get('/api/v4ward/feepay/dataProcess/sumPryMoney', Object.assign({}, options, { params }));

export const update = (params, options) =>
  request.post('/api/v4ward/feepay/dataProcess/update', params, options);
